import { INIT } from './view'
import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Board/users/'
export const REFRESH = NAMESPACE + 'REFRESH'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_ONLY_ACTIVE_LOAD_STATUS = NAMESPACE + 'SET_ONLY_ACTIVE_LOAD_STATUS'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'
export const SET_ONLY_ACTIVE_CURSOR = NAMESPACE + 'SET_ONLY_ACTIVE_CURSOR'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'

const userDefaults = {
  permissionLevel: 0
}

const defaultBoardState = {
  users: [],
  usersById: {},
  cursor: null,
  onlyActiveCursor: null,
  loading: false,
  loaded: false,
  onlyActiveLoading: false,
  onlyActiveLoaded: false
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case REFRESH:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          users: [],
          cursor: null,
          onlyActiveCursor: null,
          loading: false,
          loaded: false,
          onlyActiveLoading: false,
          onlyActiveLoaded: false
        }
      } : state
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          loading: action.payload.loading,
          loaded: action.payload.loaded
        }
      } : state
    case SET_ONLY_ACTIVE_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          onlyActiveLoading: action.payload.loading,
          onlyActiveLoaded: action.payload.loaded
        }
      } : state
    case SET_CURSOR:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          cursor: action.payload.cursor
        }
      } : state
    case SET_ONLY_ACTIVE_CURSOR:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          onlyActiveCursor: action.payload.cursor
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          users: [ ...state[action.payload.boardId].users ],
          usersById: { ...state[action.payload.boardId].usersById }
        }
      }

      action.payload.array.forEach(user => {
        newState[action.payload.boardId].users = addUniqueValueToArray({
          array: newState[action.payload.boardId].users,
          value: user.id
        })
        newState[action.payload.boardId].usersById[user.id] = {
          ...userDefaults,
          ...newState[action.payload.boardId].usersById[user.id],
          ...user
        }
      })

      return newState
    }
    default: return state
  }
}

export function refresh ({ boardId }) {
  return {
    type: REFRESH,
    payload: {
      boardId
    }
  }
}

export function setLoadStatus ({ boardId, loading, loaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      loading,
      loaded
    }
  }
}

export function setOnlyActiveLoadStatus ({ boardId, loading, loaded }) {
  return {
    type: SET_ONLY_ACTIVE_LOAD_STATUS,
    payload: {
      boardId,
      loading,
      loaded
    }
  }
}

export function setCursor ({ boardId, cursor }) {
  return {
    type: SET_CURSOR,
    payload: {
      boardId,
      cursor
    }
  }
}

export function setOnlyActiveCursor ({ boardId, cursor }) {
  return {
    type: SET_ONLY_ACTIVE_CURSOR,
    payload: {
      boardId,
      cursor
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}
